// NATIVE

// INSTALLED
import { Dispatch } from 'redux';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setLogsRedux, storeLogRedux } from './logSlice';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  activeAreaService,
  createAreaService,
  desactiveAreaService,
  getAreaDetailService,
  updateAreaDetailService,
} from '../../services/area.service';
import { types } from '../../commons/types/types';
import { getLogsByPaginateService, getLogsService } from '../../services/logs.service';

// CUSTOM

export const getLogsByPagination = (page: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    await dispatch(hideIconRequestErrors());

    const result = await getLogsByPaginateService(page);

    if (result.ok) {
      await dispatch(setLogsRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeGetLogs = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    await dispatch(hideIconRequestErrors());

    const result = await getLogsService();

    result.ok ? dispatch(hideIconRequestErrors()) : dispatch(showIconRequestErrors());

    dispatch(unCheckingPreload());

    if (result.ok) {
      // await AsyncStorage.setItem(types.storage.logsStorage, JSON.stringify(result.data.logs));
      await dispatch(setLogsRedux(result.data));
    }

    return result;
  };
};

export const setStoreLog = (log: any): any => {
  return async (dispatch: any) => {
    await dispatch(storeLogRedux(log));
  };
};
